// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#ffffff',
    },
    secondary: {
      main: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'Fredoka',
    typography: {
      fontFamily: `"Fredoka", "Helvetica", "Arial", sans-serif`,
    },
    h4: {
      fontWeight: 600,
    },
  },
});

export default theme;
